import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardImg, CardImgOverlay, CardTitle, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Loading } from './LoadingComponent';
import { baseUrl } from '../shared/baseUrl';


const RenderMenuItem = ({ dish }) => {
    return (
        <Link to={`/menu/${dish.id}`}>
            <Card>
                <CardImg width="100%" src={baseUrl + dish.image} alt={dish.name} />
                <CardImgOverlay>
                    <CardTitle>{dish.name}</CardTitle>
                </CardImgOverlay>
            </Card>
            {
                useEffect(() => {
                    window.scrollTo({
                        behavior: 'smooth',
                        top: document.getElementById("scroll-to").offsetWidth
                    });
                })
            }
        </Link>
    );
}

export const RenderMenu = (props) => {
    if (props.dishes.isLoading) {
        return (
            <Loading />
        );
    }
    else if (props.dishes.errMessage) {
        return (
            <h4 className="text-center">{props.dishes.errMessage}</h4>
        );
    }
    else {
        const menu = props.dishes.dishes.map(dish => {
            return (
                <div key={dish.id} className="col-12 col-md-5 mt-1 mb-1">
                    <RenderMenuItem dish={dish} />
                </div >
            );
        });

        return (
            <div className="container">
                <div className="row">
                    <Breadcrumb className="breadcrumb-dark">
                        <BreadcrumbItem id="breadcrumb">
                            <Link to="/home">Home</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem active>
                            <Link to="/menu">Menu</Link>
                        </BreadcrumbItem>
                    </Breadcrumb>
                    <div className="col-12">
                        <h3 id="scroll-to">Menu</h3>
                        <h6 className="mt-4 mb-4"><em>Click on the images for more information</em></h6>
                    </div>
                </div>
                <div className="row">
                    {menu}
                </div>
            </div>
        );
    }
}

export default RenderMenu;